import { useState } from 'react';

export default function KakaoFloatingButton() {
  const [isHovered, setIsHovered] = useState(false);

  const handleClick = () => {
    window.open('https://pf.kakao.com/_xnekRX/chat', '_blank');
  };

  return (
    <button
      onClick={handleClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className="fixed bottom-8 right-8 z-50 bg-[#FEE500] hover:bg-[#FDD835] text-[#3C1E1E] rounded-full shadow-2xl transition-all duration-300 cursor-pointer flex items-center justify-center"
      style={{
        width: isHovered ? 'auto' : '64px',
        height: '64px',
        padding: isHovered ? '0 24px 0 8px' : '0',
      }}
      aria-label="카카오톡 상담하기"
    >
      <div className="w-12 h-12 flex items-center justify-center flex-shrink-0">
        <i className="ri-kakao-talk-fill text-3xl"></i>
      </div>
      <span
        className="font-bold text-base whitespace-nowrap overflow-hidden transition-all duration-300"
        style={{
          maxWidth: isHovered ? '120px' : '0px',
          opacity: isHovered ? 1 : 0,
        }}
      >
        카톡 상담하기
      </span>
    </button>
  );
}
